import ScreenContainer from "../components/screen";
import { useLanguage } from "../config/language/LanguageContext";

export default function TermsAndConditions() {
  const { locale } = useLanguage();

  return (
    <ScreenContainer>
      <section id="terms-and-conditions" className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <h2 className="text-3xl font-semibold text-gray-800 text-center mb-8">
            {locale.TERMS_AND_CONDITIONS?.title || "Terms and Conditions"}
          </h2>
          
          <div className="text-gray-600 text-base leading-relaxed">
            {locale.TERMS_AND_CONDITIONS?.lastUpdated && (
              <p className="mb-8 text-center text-gray-500 italic">
                {locale.TERMS_AND_CONDITIONS.lastUpdated}
              </p>
            )}
            <div dangerouslySetInnerHTML={{ __html: locale.TERMS_AND_CONDITIONS?.content || "<p>Content coming soon...</p>" }} />
          </div>
        </div>
      </section>
    </ScreenContainer>
  );
}
